
import Header from '../components/header';
import Template from '../components/template';
import modals from '../components/modals';
import marathonTemplate from '../components/marathonTemplate';

export {
  modals,
  Header,
  marathonTemplate,
  Template
}